import React from 'react';
import { useTranslation } from 'react-i18next';
import Spinner from '@/components/UI/Spinner/Spinner';
import { statusCampaign, statusSubCampaign, VANS_LABEL } from '@/helpers/constants';
import { StatuseSummary } from '@/types';
import styles from './Dashboard.module.scss';

const addVansLabel = (status: string) => ([
  statusSubCampaign.IN_VAN_PLANT_COORDINATION as string,
  statusCampaign.IN_VAN_PLANT_IMPLEMENTATION as string,
  statusCampaign.IN_VAN_PLANT_VALIDATION as string,
].includes(status)
  ? VANS_LABEL
  : '');

type BallProps = {
  statusData: StatuseSummary;
  selected: boolean;
  onClick: () => void;
  isLoading: boolean;
  isSubCR?: boolean;
};

const Ball: React.FC<BallProps> = (props) => {
  const { statusData, onClick, selected, isLoading, isSubCR = false } = props;
  const { t } = useTranslation();

  return (
    <div
      id={statusData.name}
      data-testid={statusData.name}
      className={`${isLoading ? styles.LoadingBall : ''} ${styles.BallContent} ${selected ? styles.Selected : ''} ${isSubCR ? styles.SubCr : ''}`}
      onClick={onClick}
    >
      {!isLoading
        ? (
          <>
            <div className={styles.BallStatusName}>{t(`campaign.${statusData.name}`)}{addVansLabel(statusData.name)}</div>
            <span className={styles.BallOpenRequests}>
              <span>{`${statusData.total} ${statusData.variants ? `/` : ''}`}</span>
              <span>{statusData.variants ? `${statusData.variants.old}` : ''}</span>
            </span>
          </>
        )
        : <Spinner isVisible />}
    </div>
  );
};

export default Ball;
